/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type App_CreateCharge_QueryVariables = {
    serviceID: string;
};
export type App_CreateCharge_QueryResponse = {
    readonly service: {
        readonly " $fragmentRefs": FragmentRefs<"CreateCharge_service">;
    } | null;
};
export type App_CreateCharge_Query = {
    readonly response: App_CreateCharge_QueryResponse;
    readonly variables: App_CreateCharge_QueryVariables;
};



/*
query App_CreateCharge_Query(
  $serviceID: ID!
) {
  service: node(id: $serviceID) {
    __typename
    ... on Service {
      ...CreateCharge_service
    }
    id
  }
}

fragment CreateCharge_service on Service {
  id
  supportedCurrencies
  supportableCurrencies
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serviceID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "serviceID"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "App_CreateCharge_Query",
    "selections": [
      {
        "alias": "service",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "CreateCharge_service"
              }
            ],
            "type": "Service",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "App_CreateCharge_Query",
    "selections": [
      {
        "alias": "service",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supportedCurrencies",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supportableCurrencies",
                "storageKey": null
              }
            ],
            "type": "Service",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "804a5e9a7434148963b174a698b5c4f3",
    "id": null,
    "metadata": {},
    "name": "App_CreateCharge_Query",
    "operationKind": "query",
    "text": "query App_CreateCharge_Query(\n  $serviceID: ID!\n) {\n  service: node(id: $serviceID) {\n    __typename\n    ... on Service {\n      ...CreateCharge_service\n    }\n    id\n  }\n}\n\nfragment CreateCharge_service on Service {\n  id\n  supportedCurrencies\n  supportableCurrencies\n}\n"
  }
};
})();
(node as any).hash = '086e1c1166ad789eb760154d0b32979e';
export default node;
